import { useState, useEffect } from "react"

// helpers
import Api from "./Api"

export default function useReservationInvoices(id) {
    const [invoices, setInvoices] = useState([])
    const [loading, setLoading] = useState(true)
    const [update, setUpdate] = useState(false)

    useEffect(() => {
        if (!id) {
            return
        }

        loadData()
    }, [id, update])

    const loadData = () => {
        setLoading(true)

        Api.get(`reservations/invoices?id=${id}`)
            .then(res => {
                setInvoices(res.data)
                setLoading(false)
            })
    }

    const refresh = () => {
        setUpdate(new Date().getTime())
    }

    return {
        invoices,
        loading,
        refresh
    }
}
